import { observable } from 'mobx'
import { Model, type ModelProps } from '@/infra/model'
import type { ProvidedProfile } from '@/features/jobs/info-gathering/supporting-item-input'

/**
 * Props for {@link BusinessInfoSupportingItemInput}.
 */
export type BusinessInfoSupportingItemInputProps =
  ModelProps<BusinessInfoSupportingItemInput> & { type: 'BusinessInfo' }

/**
 * Supporting item input for business information.
 */
export class BusinessInfoSupportingItemInput extends Model<BusinessInfoSupportingItemInput> {
  /**
   * The provided profile, if any.
   */
  @observable.struct accessor provided: ProvidedProfile | null = null
}
